import React, { useMemo } from 'react';

import { useAppSelector } from 'utils/hooks';

import ui from 'domains/ui';

import activeEditor from 'domains/active_editor';

import Sidebar from 'components/features/ProductSidebar';
import PassiveTextTools from 'components/features/TextToolSidebar';
import Stage from 'components/features/Stage';
import Toolbar from 'components/features/Toolbar';
import Shuffler from 'components/features/Shuffler';
import EditorSidebar from 'components/features/EditorSidebar';
import ImageCollectionsController from 'components/features/ImageCollections/';
import Photos from 'components/features/Photos';

function EditorPage() {
  const activeCatalog = useAppSelector(activeEditor.selectors.catalog);
  const activeSubcatalog = useAppSelector(activeEditor.selectors.subcatalog);
  const showEditorSidebar = useAppSelector(ui.selectors.showEditorSidebar);
  const showMobileUserPhotos = useAppSelector(ui.selectors.showMobileUserPhotos);
  const hasMobileNavigation = useAppSelector(ui.selectors.hasMobileNavigation);
  const sidebarComponent = useAppSelector(ui.selectors.sidebarComponent);
  const hasAdvancedFilters = useAppSelector(activeEditor.selectors.hasAdvancedFilters);

  const shouldShowEditorSidebar = useMemo(() => {
    return !hasMobileNavigation || (hasMobileNavigation && showEditorSidebar);
  }, [hasMobileNavigation, showEditorSidebar]);

  const shouldShowMobilePhotos = useMemo(() => {
    return hasMobileNavigation && showMobileUserPhotos;
  }, [showMobileUserPhotos, hasMobileNavigation]);

  return (
    <React.Fragment>
      {sidebarComponent === 'TextTools' && <PassiveTextTools />}
      {sidebarComponent === 'default' && <Sidebar />}
      <div className={`wos_stage ${shouldShowMobilePhotos ? 'show-mobile-photos' : ''}`}>
        {activeCatalog && activeSubcatalog && (
          <React.Fragment>
            <Stage />
            {shouldShowEditorSidebar && <EditorSidebar />}
            <div className="wos_stage_lower">
              <Toolbar />
              <div className="user_photos_container">
                <ImageCollectionsController />
                <Photos />
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
      {hasAdvancedFilters && <Shuffler />}
    </React.Fragment>
  );
}

export default EditorPage;
